// Helper class to deal with Shopify's mechanism for redirecting users to certain
// pages after submitting a form i.e. the "return_to" input.
const FormReturnTo = {
  SELECTORS: {
    // Any forms with this attribute will have a hidden input added to redirect
    // to whatever is in the url parameter "return_to", if present.
    form: '[data-js-form-with-return-to]',
    // The hidden input described above will be tagged with this attribute.
    input: '[data-js-form-return-to-input]',
    // Any links tagged with this attribute will have whatever is in the url param
    // "return_to" added as a search param.
    linkChain: '[data-js-link-chain-return-to]',
    // Any links tagged with this attribute will have the current url path added as
    // the "return_to" search param, so that it's easy to return back to them.
    linkBack: '[data-js-link-return-back]'
  },
  init() {
    const queryParams = new URLSearchParams(window.location.search);
    const returnToUrl = queryParams.get('return_to');

    if (returnToUrl) {
      for (const form of document.querySelectorAll(this.SELECTORS.form)) {
        let input = form.querySelector(this.SELECTORS.input);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'return_to';
          input.setAttribute('data-js-form-return-to-input', '')
          input.value = returnToUrl;
          form.appendChild(input);
        }
      }

      for (const link of document.querySelectorAll(this.SELECTORS.linkChain)) {
        const url = new URL(link.href);
        if (!url.searchParams.has('return_to')) {
          url.searchParams.append('return_to', returnToUrl);
          link.href = url;
        }
      }
    }

    for (const link of document.querySelectorAll(this.SELECTORS.linkBack)) {
      const currentPath = new URL(window.location).pathname;
      const linkUrl = new URL(link.href);
      if (!linkUrl.searchParams.has('return_to')) {
        linkUrl.searchParams.append('return_to', currentPath);
        link.href = linkUrl;
      }
    }
  }
};

window.addEventListener('DOMContentLoaded', () => {
  FormReturnTo.init();
});

document.addEventListener('shopify:section:load', () => {
  FormReturnTo.init();
});
